import { IndependentGlossarySidebar } from '@new/__global/components/GlossarySidebar/IndependentGlossarySidebar'

export function GlobalGlossarySidebar() {
  return <IndependentGlossarySidebar />
}
